import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useEffect } from 'react';

const PortFolioDetails = ({ site, closeModal }) => {
	useEffect(() => {
		document.body.style.overflow = 'hidden';
	}, []);
	return (
		<>
			<div className="modal-element-container">
				<div className="modal-element-image-carousel">
					<Carousel
						axis={'horizontal'}
						showThumbs={false}
						swipeAnimationHandler={true}
						infiniteLoop={true}
						autoPlay={true}
						showStatus={false}
					>
						{site.content.images.map((image) => {
							return (
								<div
									key={image}
									className="element-image-carousel"
								>
									
									<img
										src={image}
										alt="portfolio"
										height={site.platform === 'mobile' && 500}
										width={site.platform === 'mobile' ? '' : '100%'}
									/>
									
								</div>
							);
						})}
					</Carousel>
				</div>
				<div className="modal-element-description">
					<ul className="modal-element-description-list">
						<h2>Description</h2>
						<li>
							<div>
								<ion-icon
									className="modal-icon"
									name="alert-circle-outline"
								></ion-icon>
							</div>
							<span>{site.content.description}</span>
						</li>
						<h2>My role</h2>
						<li>
							<div>
								<ion-icon
									className="modal-icon"
									name="person-outline"
								></ion-icon>
							</div>
							<span>{site.content.myRole}</span>
						</li>
						<h2>Difficulties</h2>
						<li>
							<div>
								<ion-icon
									className="modal-icon"
									name="construct-outline"
								></ion-icon>
							</div>
							<span>{site.content.difficulties}</span>
						</li>
						<h2>Solutions</h2>
						<li>
							<div>
								<ion-icon
									className="modal-icon"
									name="bulb-outline"
								></ion-icon>
							</div>
							<span>{site.content.mySolution}</span>
						</li>
						<h2>Notable features</h2>
						<li>
							<div>
								<ion-icon name="extension-puzzle-outline"></ion-icon>
							</div>
							<ol>
								{site.content.NotableFeatures.map((features, index) => {
									return <li key={index}>•{features}</li>;
								})}
							</ol>
						</li>
						<div className="portfolios-links">
							{site.repository.live || site.repository.frontend || site.repository.backend || site.repository.merchand ? <h2> Links</h2> : null}

							{site.repository.live && (
								<li>
									<div>
										<ion-icon
											className="modal-icon"
											name="globe-outline"
										></ion-icon>
									</div>
									<a
										href={site.repository.live}
										target="_blank"
										rel="noreferrer"
									>
										Live demo
									</a>
								</li>
							)}
							{site.repository['frontend'] && (
								<li>
									<div>
										<ion-icon
											className="modal-icon"
											name="logo-github"
										></ion-icon>
									</div>
									<a
										href={site.repository.frontend}
										target="_blank"
										rel="noreferrer"
									>
										Github frontend repository
									</a>
								</li>
							)}
							{site.repository['backend'] && (
								<li>
									<div>
										<ion-icon
											className="modal-icon"
											name="logo-github"
										></ion-icon>
									</div>
									<a
										href={site.repository.backend}
										target="_blank"
										rel="noreferrer"
									>
										Github backend repository
									</a>
								</li>
							)}
							{site.repository['merchand'] && (
								<li>
									<div>
										<ion-icon
											className="modal-icon"
											name="globe-outline"
										></ion-icon>
									</div>
									<a
										href={site.repository.merchand}
										target="_blank"
										rel="noreferrer"
									>
										Official Website
									</a>
								</li>
							)}
						</div>
					</ul>
				</div>
				<div
					className="close-modal-button"
					onClick={() => {
						closeModal(true);
					}}
				>
					<ion-icon name="close-outline"></ion-icon>
				</div>
			</div>
		</>
	);
};
export default PortFolioDetails;
